"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import SecurityServicesTabs from "@/components/pageTabs/securityServicesTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import WhyOneMindComponent from "./components/whyOnemind";
import OfferingsComp from "./components/offerings";
import FeaturesComp from "./components/features";
import StandardsComp from "./components/standards";

const ComplianceManagementPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout>
        <SecurityServicesTabs />
        <Intro />
      </PageLayout>
      <FeaturesComp />
      <PageLayout>
        <WhyOneMindComponent />
      </PageLayout>
      <OfferingsComp />
      <StandardsComp />
      <PageLayout showContactForm>
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default ComplianceManagementPage;
